/****************************************************************************
 * Copyright (C) 2014-2016 ecsec GmbH.
 * All rights reserved.
 * Contact: ecsec GmbH (info@ecsec.de)
 *
 * This file is part of SkIDentity.
 *
 * This file may be used in accordance with the terms and conditions
 * contained in a signed written agreement between you and ecsec GmbH.
 *
 ***************************************************************************/

export enum LogLevel {
	log = 0,
	info = 1,
	warn = 2,
	error = 3,
	debug = 4
}

export class Logger {

	private static logs: Log[] = new Array();
	private clazz: string;
	private static isDev: boolean = true;
	private static loglevel: LogLevel = LogLevel.debug;

	public constructor(classpath: string) {
		Logger.setProd();
		this.clazz = classpath;
		this.debug("Created Logger for: " + this.clazz);
	}

	public log(message: any): void {
		Logger.appendLog(this.clazz, LogLevel.log, message);
	}

	public info(message: any): void {
		Logger.appendLog(this.clazz, LogLevel.info, message);
	}

	public warn(message: any): void {
		Logger.appendLog(this.clazz, LogLevel.warn, message);
	}

	public error(message: any): void {
		Logger.appendLog(this.clazz, LogLevel.error, message);
	}

	public debug(message: any): void {
		Logger.appendLog(this.clazz, LogLevel.debug, message);
	}

	private static appendLog(clazz: string, type: LogLevel, message: string) {
		let log = new Log(clazz, type, message);
		this.logs.push(log);
		if (this.canLog(type)) {
			log.logToConsole();
		}
	}

	private static canLog(type: LogLevel): boolean {
		if (!this.isDev) {
			return false;
		}
		if (type <= this.loglevel) {
			return true;
		}
	}

	public static setLogLevel(type: LogLevel) {
		this.loglevel = type;
	}

	public static setProd(): void {
		this.isDev = false;
	}
}

class Log {

	private time: Date = new Date();
	private clazz: string;
	private type: LogLevel;
	private message: string;

	public constructor(clazz: string, type: LogLevel, message: string) {
		this.clazz = clazz;
		this.type = type;
		this.message = message;
	}

	public logToConsole(): void {
		switch (this.type) {
			case LogLevel.log:
				console.log(this.time, this.type, this.clazz, this.message);
				break;
			case LogLevel.info:
				console.info(this.time, this.type, this.clazz, this.message);
				break;
			case LogLevel.warn:
				console.warn(this.time, this.type, this.clazz, this.message);
				break;
			case LogLevel.error:
				console.error(this.time, this.type, this.clazz, this.message);
				break;
			case LogLevel.debug:
				console.debug(this.time.toString(), this.type, this.clazz, this.message);
				break;
			default:
				break;
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/@ecsec/base-libs/src/util/Logger.ts